module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"title":"Mois de l\u0027économie sociale"},"en":{"title":"Social Economy Month"}}')
  delete Component.options._Ctor
}
